import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const reviews = [{
  name: 'Aisha B.',
  image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=100&h=100&fit=crop&crop=face',
  text: 'Me dijo exactamente lo que mi ex iba a hacer, y pasó tal cual. Su precisión es increíble. No puedo recomendarla lo suficiente.'
}, {
  name: 'Jennifer S.',
  image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=100&h=100&fit=crop&crop=face',
  text: 'Lo que más valoro es el seguimiento. Meses después de mi lectura, todavía responde mis preguntas. Eso no tiene precio.'
}];
export function FinalReviews() {
  return <section className="w-full py-20 px-4 bg-[#0a0a0a]" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-125">
          {reviews.map((review, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-[#111] border border-white/5 p-8 rounded-2xl hover:border-[#D4AF37]/30 transition-colors flex flex-col" data-id="element-126">
              <div className="flex items-center gap-3 mb-6" data-id="element-127">
                <img src={review.image} alt={review.name} className="w-12 h-12 rounded-full object-cover border border-white/10" data-id="element-128" />
                <div data-id="element-129">
                  <p className="font-inter text-[#D4AF37] font-semibold uppercase tracking-wider text-sm" data-id="element-130">
                    {review.name}
                  </p>
                  <div className="flex gap-0.5" data-id="element-131">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" data-id="element-132" />)}
                  </div>
                </div>
              </div>
              <p className="font-playfair text-gray-200 text-lg sm:text-xl leading-relaxed flex-grow italic" data-id="element-133">
                "{review.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}